export default {
    getQueryFromUrl: (state, pageSize, getQueryConstants) => {

        let params = window.location.pathname.split('/');
        let output = getQueryConstants(state, pageSize);

        let count = 0;
        params.forEach(field => {

            if(count > 2 && field) {
                let fieldItems = field.split('_');
                if(fieldItems.length > 1)
                    output = `${output}&${fieldItems[0]}=${fieldItems[1]}`;
            }
            count ++;
        })

        // Check for preset areas from data attribute (for geographic area pages)
        const preSetAreasElement = document.querySelector('[data-preset-areas]');
        if (preSetAreasElement && preSetAreasElement.dataset.presetAreas) {
            try {
                const preSetAreas = JSON.parse(preSetAreasElement.dataset.presetAreas);
                if (preSetAreas && preSetAreas.length > 0) {
                    // Only add preset areas if there's no area filter already in the URL
                    if (!output.includes('&area=')) {
                        const areasValue = preSetAreas.join(',');
                        output = `${output}&area=${areasValue}`;
                        console.log('[listingRepoHelper] Added preset areas to initial query:', areasValue);
                    }
                }
            } catch (e) {
                console.error('[listingRepoHelper] Error parsing preset areas:', e);
            }
        }

        return output;
    },
    getQueryFromState: (state, pageSize, getQueryConstants) => {
    
        let output = getQueryConstants(state, pageSize);
    
        Object.keys(state.filters).forEach((key) => {
            var rawValue = state.filters[key];
            if(Array.isArray(rawValue)) {
                var value = rawValue.join(',');
                if(value && value != 'all')
                    output = `${output}&${key}=${value}`;
            }
            else {
                output = `${output}&${key}=${rawValue}`;
            }
        });
    
        return output;
    }
}